<template>
  <div id="app" v-if="menuDataReady">
    <div class="appWrap fill-parent">
      <div class="right-container">
        <div class="top-content">
          <navigation-top @on-select-account="onSelectAccount" />
        </div>
        <div class="main-content">
          <div class="body-view">
            <!-- <div class="left-view">
              <div class="user-msg">
                <div class="msg-left">
                  <img
                    class="user-avatar"
                    src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                  />
                </div>
                <div class="msg-right">
                  <div class="user-name">
                    <span>{{commonData.USERNAME}}</span>
                    <span class="edit-icon el-icon-edit"></span>
                  </div>
                  <div class="user-level">
                    <span>{{commonData.ROLENAME}}</span>
                  </div>
                </div>
              </div>
              <div class="user-msg-list">
                <div class="msg-list">
                  <div class="inputbox el-icon-phone">
                    <input
                      v-model="model.username"
                      autocomplete="off"
                      placeholder
                      class="username full"
                      type="text"
                    />
                  </div>
                  <span class="edit-icon el-icon-edit"></span>
                </div>
                <div class="msg-list">
                  <div class="inputbox kebai-icons-lock">
                    <input
                      v-model="model.username"
                      autocomplete="off"
                      placeholder
                      class="username full"
                      type="password"
                    />
                  </div>
                  <span class="edit-icon el-icon-edit"></span>
                </div>
                <div class="msg-list">
                  <div class="inputbox el-icon-message">
                    <input
                      v-model="model.username"
                      autocomplete="off"
                      placeholder
                      class="username full"
                      type="text"
                    />
                  </div>
                  <span class="edit-icon el-icon-edit"></span>
                </div>
              </div>
              <div class="btn-view">
                <div class="list-btn">
                  <div class="inputbox" style="margin-top: 40px;">
                    <input class="button button-login submit full" value="修改密码" type="button" />
                  </div>
                </div>
                <div class="list-btn">
                  <div class="inputbox" style="margin-top: 20px;" @click="clickLogout">
                    <input class="button button-login signout full" value="注销登录" type="button" />
                  </div>
                </div>
              </div>
            </div>-->
            <div class="top-view">5G智慧农业全产业链大数据中心</div>
            <div class="right-view">
              <div class="list-row" v-for="(item,index) in systemArr" :key="index">
                <div class="left-content">
                  <img class="img-src" :src="item.imgsrc" alt />
                </div>
                <div class="right-content">
                  <div class="title-name">
                    <span>{{item.name}}</span>
                  </div>
                  <!-- <div class="describe-content">
                      <span>{{item.describe}}</span>
                  </div>-->
                  <div class="enter-system" @click="linkSso(item)">
                    <span class="btn-span">进入系统</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="login-footer">
              <p class="p-height">Copyright©1999-2020 中国移动 版权所有 本网站支持IPv6访问</p>
              <p class="p-height">中华人民共和国增值电信业务经营许可证 经营许可证编号：A2.B1.B2-20100001</p>
              <p class="p-height marginTop">技术支持：中国移动通信集团有限公司</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavigationTop from "@/components/navigation/top.vue";
import ApiRequest from "./api-main";
import CommonData from "@/services/model/common-data";
import pathConfig from "@/config/pathConfig";

export default {
  components: {
    NavigationTop,
  },
  data() {
    return {
      commonData: new CommonData(this),
      apiRequest: new ApiRequest(this),
      menuDataReady: true,
      isFirstLoad: true,
      model: {
        username: "15333208854",
        password: null,
      },
      systemArr: [
        {
          name: "5G智慧农业全产业链大数据中心",
          type: 1,
          imgsrc: require("@/assets/images/bigdata.png"),
          path: pathConfig.bigData,
          describe:
            "按照曲沃县关于5G智慧农业全产业链大数据中心的总体规划，围绕农业地理信息应用服务需求，运用地理信息、云计算、空间大数据等先进成熟技术，以信息资源整合工作为核心，以农业大数据空间化与大数据分析挖掘为应用主线，进一步整合完善农业地理信息数据资源，实现基于云GIS技术架构和空间大数据技术支撑的农业地理信息服务能力，完善农业地理信息服务应用规范，形成长效的运行维护管理机制，全面提升全行业的地理信息大数据应用水平。",
        },
        {
          name: "溯源系统平台",
          type: 2,
          imgsrc: require("@/assets/images/suyuan.png"),
          path: pathConfig.source,
          describe:
            "溯源系统是物联网、移动互联网、一物一码等技术的整合应用。在产品生产过程中在重要环节可采集产品数据信息并形成产品溯源档案。从而形成产品从原料、生产加工、质量检测、物流运输等环节的信息监控。",
        },
        {
          name: "精准种植",
          type: 3,
          imgsrc: require("@/assets/images/wulianwang.png"),
          path: pathConfig.quwoCloud,
          describe:
            "精准种植，即通过各种仪器仪表实时显示或作为自动控制的参变量参与到自动控制中的物联网。可以为温室精准调控提供科学依据，达到增产、改善品质、调节生长周期、提高经济效益的目的。",
        },
        {
          name: "植保防控系统",
          isclick: true,
          imgsrc: require("@/assets/images/plantProtect.png"),
          path: pathConfig.plantProtect,
          describe:'',
        },
        {
          name: "大数据管理",
          type: 4,
          imgsrc: require("@/assets/images/houtai.png"),
          path: pathConfig.quwoback,
          describe:
            "主要负责服务平台中核心的服务资源的管理。通过平台管理模块可以更方便的管理服务平台的运行状况，保证系统安全可靠的运行。",
        },
        {
          name: "权限管理",
          type: 5,
          imgsrc: require("@/assets/images/quanxian.png"),
          path: pathConfig.febs,
          describe: "新增用户，给用户分配权限。",
        },

        {
          name: "物联网管理系统",
          type: 6,
          imgsrc: require("@/assets/images/yewu.png"),
          path: pathConfig.system,
          describe: "新增项目，给用户配置项目权限。",
        },
        {
          name: "ERP系统",
          type: 7,
          imgsrc: require("@/assets/images/houtai.png"),
          path: pathConfig.erp,
          describe: "新增项目，给用户配置项目权限。",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    let that = this;
    // window.loading(false);
    this.checkToken();
  },
  methods: {
    checkToken() {
      console.log("token", this.$localStorage.get("access_token"));
      const token = this.$localStorage.get("access_token");
      if (!token)
        window.location.href = window.prePath + "/index.html?web#/login";
      else this.queryLandAreaList();
    },

    queryLandAreaList() {
      this.apiRequest.queryLandAreaList().then((res) => {
        console.log("gogoggo");
      });
    },
    onSelectAccount() {
      window.location.reload();
    },
    linkSso(data) {
      if (data.name != "植保防控平台") {
        window.location.href = data.path;
      } else {
        window.open(data.path);
      }
    },
    clickLogout() {
      localStorage.clear();
      window.location.href = window.backPath;
    },
  },
  watch: {},
};
</script>

<style lang="scss">
@import "./../../components-base/element-rewrite/_index.scss";
</style>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
/*滚动条样式修改*/
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #d0d0d0;
}
.appWrap {
  height: 100%;
  display: flex;
  // background: url("~@/assets/images/pagesbj.png") no-repeat;
  // background-size: 100% 100%;
  background: #222222;
  .left-container {
    width: 60px;
    height: 100%;
  }
  .right-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .top-content {
      height: 60px;
      background: url("~@/assets/images/headerbj.png") no-repeat;
      background-size: 100% 100%;
      box-shadow: 0 4px 0 rgba(0, 0, 0, 0.4);
    }
    .main-content {
      width: 100%;
      height: calc(100% - 60px);
      overflow: hidden;
      .body-view {
        box-sizing: border-box;
        // padding: 28px 60px 0 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        height: 100%;
        overflow: auto;
        .left-view {
          width: 360px;
          margin-right: 40px;
          height: 540px;
          padding: 32px 34px;
          background-color: rgba(51, 51, 51, 0.5);
          border-radius: 0 0 4px 4px;
          overflow: hidden;
          .user-msg {
            display: flex;
            align-items: center;
            .msg-left {
              width: 82px;
              height: 82px;
              border: 4px solid #878787;
              border-radius: 40px;
              overflow: hidden;
              .user-avatar {
                width: 74px;
                height: 74px;
              }
            }
            .msg-right {
              flex: 1;
              margin-left: 10px;
              .user-name {
                color: #ffffff;
                font-size: 17px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .edit-icon {
                  cursor: pointer;
                  color: #999;
                }
              }
              .user-level {
                margin-top: 8px;
                font-size: 15px;
                color: #02aa9f;
              }
            }
          }
          .user-msg-list {
            margin-top: 30px;
            .msg-list {
              height: 55px;
              border-bottom: 2px solid #3a3a3a;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .edit-icon {
                cursor: pointer;
                color: #999;
                font-size: 17px;
              }
              .inputbox {
                position: relative;
                display: inline-flex;
                justify-content: space-between;
                line-height: 30px;
                height: 30px;
                text-align: center;
                &::before {
                  position: absolute;
                  color: #c6c6c6;
                  font-size: 20px;
                  left: 0px;
                  top: 0px;
                  box-sizing: border-box;
                  width: 30px;
                  height: 30px;
                  line-height: 30px;
                }
                input {
                  color: #666666;
                  background: transparent;
                  background-color: transparent;
                  outline: none;
                  line-height: 30px;
                  font-size: 14px;
                  border-radius: 4px;
                  vertical-align: middle;
                  border: 0;
                }
                input[type="text"],
                input[type="password"] {
                  padding-left: 40px;
                  letter-spacing: 1px;
                  box-sizing: border-box;
                  outline: none;
                }
              }
            }
          }
          .btn-view {
            width: 100%;
            .list-btn {
              width: 100%;
            }
            .inputbox {
              position: relative;
              display: inline-flex;
              width: 100%;
              justify-content: space-between;
              line-height: 30px;
              height: 30px;
              text-align: center;
              .full {
                width: 100%;
              }
            }
            input {
              color: #e3e3e3;
              background: #606060;
              background-color: #606060;
              outline: none;
              line-height: 30px;
              font-size: 14px;
              border-radius: 4px;
              vertical-align: middle;
              border: 0;
            }
            input[type="button"] {
              cursor: pointer;
              border: 1px solid #606060;
            }
            input[type="button"].signout {
              background-color: #00b2a6;
              border: 1px solid #00b2a6;
            }
          }
        }
        .top-view {
          width: 100%;
          height: 120px;
          color: #ffffff;
          font-size: 32px;
          text-align: center;
          line-height: 120px;
        }
        .right-view {
          width: 90%;
          // background-color: rgba(51, 51, 51, 0.5);
          // padding: 25px 40px 0 40px;
          // min-height: 730px;
          // overflow: hidden;
          // overflow-y: auto;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-content: center;
          .list-row {
            width: 30%;
            margin-bottom: 26px;
            width: 395px;
            height: 260px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            background: #2a2a2a;
            margin: 12px;
            transition: box-shadow 0.4s, transform 0.4s;
            border-radius: 4px;
            .left-content {
              // width: 100%;
              // height: 100%;
              // border-radius: 7px;
              margin-bottom: 10px;
              // overflow: hidden;
              .img-src {
                // width: 100%;
                height: 141px;
              }
            }
            .right-content {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              padding-bottom: 10px;
              .title-name {
                font-size: 18px;
                color: #ffffff;
              }
              .describe-content {
                font-size: 12px;
                color: #999;
                line-height: 17px;
              }
              .enter-system {
                margin-top: 15px;
                width: 100px;
                height: 30px;
                line-height: 27px;
                color: #ffffff;
                font-size: 14px;
                text-align: center;
                border: 1px solid #707070;
                border-radius: 4px;
                cursor: pointer;
              }
              // .enter-system:hover {
              //   background-color: #00b2a6;
              //   border: 1px solid #00b2a6;
              // }
            }
          }
          .list-row:hover {
            transform: translateY(-2%);
            box-shadow: 0px 6px 30px rgba(0, 0, 0, 0.53);
            .enter-system {
              background-color: #00b2a6;
              border: 1px solid #00b2a6;
            }
          }
        }
        .login-footer {
          margin-top: 30px;
          bottom: 40px;
          font-size: 12px;
          color: #8c8c8c;
          width: 100%;
          text-align: center;
          .p-height {
            line-height: 17px;
          }
          .marginTop {
            margin-top: 40px;
          }
        }
      }
    }
  }
}
</style>